// removed by extract-text-webpack-plugin
module.exports = {"Step4":"Step4","Title":"Title","ServiceRegister":"ServiceRegister","ProgressBar":"ProgressBar","ServiceTitle":"ServiceTitle","SignRegister":"SignRegister","SignTitle":"SignTitle","ServiceInfo":"ServiceInfo","Subtitle":"Subtitle","FileUpload":"FileUpload","InputContainer":"InputContainer","Note":"Note","WarningNote":"WarningNote","CustomFileInput":"CustomFileInput","btnContainer":"btnContainer","CheckboxContainer":"CheckboxContainer","CheckBox":"CheckBox","Step4Mobile":"Step4Mobile","form-row":"form-row"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step4/style.scss
// module id = 2316
// module chunks = 10